import {createSelector} from 'reselect';
import {ISnapData} from './types';
import {AppState} from './../../../store';

export const ugcDataSelector = createSelector<ISnapData, object, object>(
  state => state.snapData,
  snapData => snapData,
);

export const qnaFilterData = (state: AppState) => state.ugc.qnaFilterData;
export const qnaData = (state: AppState) => state.ugc.qnaData;
export const pendingQnaData = (state: AppState) => state.ugc.pendingQnaData;

export const hasQnaData = (state: AppState) => state.ugc.hasQnaData;
export const hasQnaDataSelector = createSelector(hasQnaData, hasQnaData => hasQnaData);

export const qnaPaginatorStatus = (state: AppState) => state.ugc.qnaPaginatorStatus;
export const qnaDetailType = (state: AppState) => state.ugc.qnaDetailType;
export const newQuestions = (state: AppState) => state.ugc.newQuestions;
export const selTagIds = (state: AppState) => state.ugc.selTagIds;
export const selRnrTagIds = (state: AppState) => state.ugc.selRnrTagIds;

export const giSnapData = (state: AppState) => state.ugc.snapData.giData;
export const snapData = (state: AppState) => state.ugc.snapData;

export const selectedRnRType = (state: AppState) => state.ugc.selectedRnRType;

export const hasData = (state: AppState) => state.ugc.hasData;
export const hasSnapDataSelector = createSelector(hasData, hasData => hasData);

export const hasReviewData = (state: AppState) => state.ugc.hasReviewData;
export const hasReviewDataSelector = createSelector(hasReviewData, hasReviewData => hasReviewData);

export const reviewDetailType = (state: AppState) => state.ugc.reviewDetailType;

export const taTagData = (state: AppState) => state.ugc.snapData?.taData?.hdpTags || [];
export const taTagDataSelector = createSelector(taTagData, taTagData => taTagData);

export const giTagData = (state: AppState) => state.ugc.snapData?.giData?.hdpTags || [];
export const giTagDataSelector = createSelector(giTagData, giTagData => giTagData);
